import { render, staticRenderFns } from "./BlockEditor.vue?vue&type=template&id=7714d4c0&scoped=true&"
import script from "./BlockEditor.vue?vue&type=script&lang=js&"
export * from "./BlockEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7714d4c0",
  null
  
)

export default component.exports